// @flow
import axios from 'axios';
import { isMobileBrowser, isMobileEmbedded, isiOS } from '@rover/utilities/userAgent';
import { getCookie } from '@rover/utilities/cookie';
import type { AxiosUtilsInterface, ExpressParams } from '@rover/react-lib/types';
import reportError from '@rover/utilities/reportError';

import axiosErrorHandler from './axiosErrorHandler';

export const DEFAULT_CSRF_COOKIE_NAME = 'csrftoken';
export const CSRF_META_TAG_NAME = 'csrf-cookie-name';

export const getCsrfCookieName = (): string => {
  const meta = document.querySelector(`meta[name=${CSRF_META_TAG_NAME}]`);
  const metaCookieName = meta && meta.getAttribute('content');
  return metaCookieName || DEFAULT_CSRF_COOKIE_NAME;
};

export const getSourceDescription = (): string => {
  const { userAgent } = navigator;
  if (!userAgent || !userAgent.length || !isMobileBrowser(userAgent)) return 'web'; // If the user agent string doesn't exist, assume this is a web request
  if (!isMobileEmbedded()) return 'mobile_web';
  return isiOS(userAgent) ? 'ios' : 'android';
};

export const getSourceHeader = () => {
  const source = getSourceDescription();
  return { 'X-Rover-Source': source };
};

export const getCsrfToken = () => getCookie(getCsrfCookieName());

export const isRoverUrl = (url: string) =>
  url.includes(window.location.hostname) ||
  url.startsWith('/') ||
  url.startsWith('./') ||
  url.startsWith('../');

export const addRoverHeaders = (config: any) => {
  const roverConfig = { ...config };
  const token = getCsrfToken();

  roverConfig.headers.common = {
    ...config.headers.common,
    ...getSourceHeader(),
    ...(token && { 'X-CSRFToken': token }),
  };

  return roverConfig;
};

export const createRequestInterceptor = () => (defaultConfig: any) => {
  const isRover = isRoverUrl(defaultConfig.url);
  if (!isRover) return defaultConfig; // non-rover urls get NOTHING, to avoid CORS issues
  const configWithHeaders = addRoverHeaders(defaultConfig);
  return configWithHeaders;
};

export const getAxiosInstance = (expressParams: ?ExpressParams) => {
  if (expressParams) reportError('Error in axiosUtils.client.js: expressParams was found');
  const ai = axios.create();
  ai.interceptors.request.use(createRequestInterceptor(), axiosErrorHandler);
  return ai;
};

const axiosUtils: AxiosUtilsInterface = { getAxiosInstance };

export default axiosUtils;



// WEBPACK FOOTER //
// ../utilities/axiosUtils/axiosUtils.client.js